import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import { browserHistory } from 'react-router';
import { Row, Col, Panel } from 'react-bootstrap';
import windowSize from 'react-window-size';
import Iframe from 'react-iframe';
import StripeCheckout from 'react-stripe-checkout';
import _ from 'lodash';
import $ from 'jquery';
import request from 'axios';
import TextInput from './common/TextInput';
import FormField from './common/FormField';
import CheckBox from './common/CheckBox';
import Table from './common/Table';
import Button from './common/Button';
import AutoComplete from './common/AutoComplete';
import SendEmailForm, { isEmailIntegrated } from './common/SendEmailForm';
import EmailSignatureDialog from './common/EmailSignatureDialog';
import ResetPasswordForm from './common/ResetPasswordForm';
import TwoFactorAuth from './common/TwoFactorAuth';
import LoadingProgressBar from './common/LoadingProgressBar';
import ConfirmDialog from './common/ConfirmDialog';
import ConditionsAndPolicyLinks from './common/ConditionsAndPolicyLinks';
import PaymentProvider from './common/PaymentProvider';
import { signUpUserFormAction,
         userSubscriptionValidateCoupon,
         updateMyAccountUserAction,
         addEmployeeUserAction,
         deleteEmployeeUserAction,
         userFeedbackAction,
         userCalendarDefaultAction,
         userCalendarListAction,
         userEmailReadAction,
         userLogInLoadAction,
         userDriveConfigAction,
         userDriveListAction } from '../actions/userActions';

import * as validators from '../validators/formValidators';
import { isEmptyObject,
         isEmptyString } from '../validators/formValidators';

import { caseSetServerError } from '../actions/caseActions';
import { retrieveNotifications,
         getCouponInfo,
         getDateFromUTC,
         isAdmin,
         getUrlVars, 
         findBootstrapEnvironment } from '../helpers/utils';

import { getSupportedCountriesOptions, getStatesOptions, getStatesLabel, getCountry } from '../helpers/internationalization';
import { getClientAuthHeader } from '../../client/token';
import RegisterSmsPhoneForm from './common/RegisterSmsPhoneForm';
import RegisterSubscriptionApiKeyForm from './common/RegisterSubscriptionApiKeyForm';
import TextArea from './common/TextArea';
import { getPaymentAccount, isDemoAccount } from './../helpers/utils';
import Select from './common/Select';
import DriveIntegration, { isDriveIntegrated } from './common/DriveIntegration';

export const fields = ['FirstName', 'LastName', 'CompanyName', 'Country', 'PracticeState', 'Email', 'Password', 'Coupon', '$LoggedInEmail$'];

const asyncValidateEmail = (props) => {
    const email = props.values['Email'];
    let error = validators.validateRequired(email, 'Email');
    if (validators.isEmptyObject(error)) {
        error = validators.validateEmail(email, 'Email');
    }

    if (!isEmptyObject(error)) {
        props.setFieldError('Email', error['Email']);
        return undefined;
    }

    return new Promise((resolve, reject) => {
        request.get(`/api/v1/user/exists/${encodeURIComponent(email)}`, getClientAuthHeader())
               .then((result) => {
                    const userExists = result.data;
                    if (userExists) {
                        const error = {'Email': 'Email is already taken.'};
                        props.setFieldError('Email', error['Email']);
                        resolve(error);
                    } else {
                        props.setFieldError('Email', undefined)
                        resolve({});
                    }
               })
               .catch((error) => {
                    console.error(new Error().stack, error);
                    const err = {'Email': 'Email cannot be validated at the moment.'};
                    props.setFieldError('Email', error['Email']);
                    reject(err);
               });
    });
};


export const validateSignUpForm = async (values, props = undefined) => {
    let errors = {};
    let username = values['Email'];
    let password = values['Password'];
    let firstName = values['FirstName'];
    let lastName = values['LastName'];
    let companyName = values['CompanyName'];
    let practiceState = values['PracticeState'];
    let country = values['Country'];

    let error = validators.validateRequired(username, 'Email');
    if (validators.isEmptyObject(error)) {
        error = validators.validateEmail(username, 'Email');
    }

    if (validators.isEmptyObject(error)) {
        try {
            const result = await request.get(`/api/v1/user/exists/${encodeURIComponent(username)}`, getClientAuthHeader())
            const userExists = result.data;
            if (userExists) {
                error = {'Email': 'Email is already taken.'};
            }
        } catch(error) {}
    }

    errors = { ...errors, ...error };
    if (!props || !props.loggedIn) {
        error = validators.validateRequired(password, 'Password');
        if (validators.isEmptyObject(error)) {
            error = validators.validateText(password, 'Password', 50);
        }

        errors = { ...errors, ...error };
    }

    error = undefined;
    if (props.loggedIn) {
        error = validators.validateRequired(firstName, 'FirstName');
    }

    error = error || validators.validateText(firstName, 'FirstName', 100);
    errors = { ...errors, ...error };

    if (props.loggedIn) {
        error = validators.validateRequired(lastName, 'LastName');
    }

    error = error || validators.validateText(lastName, 'LastName', 100);
    if (!props.employee) {
        errors = { ...errors, ...error };
        if (props.loggedIn) {
            error = validators.validateRequired(companyName, 'CompanyName');
        }

        error = error || validators.validateText(companyName, 'CompanyName', 100);
        // TODO: verify state is correct
        errors = { ...errors, ...error };
        error = validators.validateText(practiceState, 'PracticeState', 2);
    }

    errors = { ...errors, ...error };
    if (!isEmptyObject(errors)) {
        throw errors;
    }
};


class SignUpForm extends PureComponent {
    constructor(props) {
        super(props);
        this.proceed = this.proceed.bind(this);
        this.proceedToCheckout = this.proceedToCheckout.bind(this);
        this.logIn = this.logIn.bind(this);
        this.signUp = this.signUp.bind(this);
        this.save = this.save.bind(this);
        this.employeeSave = this.employeeSave.bind(this);
        this.employeeDialogClose = this.employeeDialogClose.bind(this);
        this.deleteEmployee = this.deleteEmployee.bind(this);
        this.deleteEmployeeConfirm = this.deleteEmployeeConfirm.bind(this);
        this.checkEmail = this.checkEmail.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.deleteAccountConfirm = this.deleteAccountConfirm.bind(this);
        this.state = {
            loading: false,
            finalPrice: process.env.SUBSCRIPTION_PRIVATE_BETA_COST,
            selectedPrice: process.env.SUBSCRIPTION_PRIVATE_BETA_COST,
            couponDescription: undefined,
            signingUp: false,
            dialogTitle: '',
            dialogWarning: false,
            dialogUrl: undefined,
            dialogText: undefined,
            agreeChecked: false,
            couponChecked: false,
            dialogOpened: false,
            dialogConfirm: undefined,
            dialogSize: 'large',
            employee: undefined,
            emailSignatureDialogOpened: false,
            deleteAccountDialog: false,
            deleteAccountMessage: undefined,
            deleteAccountDialogLoading: false,
            calendarIds: undefined,
            driveIds: undefined,
            driveRootFolder: undefined
        };
    }

    async componentDidMount() {
        if (this.props.signupDialog) {
            $('html').css('overflow-x', 'hidden');
            $('html').css('overflow-y', 'auto');
        }
    }

    async componentWillReceiveProps() {
        try {
            if (isEmailIntegrated(this.props.loggedIn) && this.props.loggedIn['GmailAccount'] && this.state.calendarIds == undefined) {
                const response = await this.props.dispatch(userCalendarListAction());
                this.setState({calendarIds: response.data});
            }

            if (isDriveIntegrated(this.props.loggedIn) && this.props.loggedIn['GDriveAccount'] && this.state.driveIds == undefined) {
                const response = await this.props.dispatch(userDriveListAction('gdrive'));
                this.setState({driveIds: response.data});
            }
        } catch (e) {
            console.error(e);
        }
    }

    signUp(token) {
        let data = this.props.values;
        data['$StripeCardToken$'] = token;
        this.setState({loading: true, signingUp: true});
        if (!data['$StripeCardToken$']) {
            debugger;
            this.setState({loading: false});
            this.props.dispatch(caseSetServerError('Card token missing (Stripe error)'));
            return;
        }

        delete data['$LoggedInEmail$'];
        this.props.dispatch(signUpUserFormAction(data))
            .then((result) => {
                if (this.props.signupDialog) {
                    console.log('Redirecting to the app ...');
                    window.parent.location.href = __DOMAIN_NAME__ + '/';
                    return;
                } else {
                    browserHistory.push('/');
                }
                retrieveNotifications(this.props.dispatch);
                this.setState({loading: false, signingUp: false});
            })
            .catch((error) => {
                console.error(new Error().stack, error);
                this.props.dispatch(caseSetServerError(error));
                this.setState({loading: false, signingUp: false});
            });
    }

    save(data) {
        data = {...this.props.loggedIn, ...data};
        delete data['$LoggedInEmail$'];
        this.props.dispatch(updateMyAccountUserAction(data))
            .then(result => {
                this.setState({loading: false});
                if (this.props.personalInformationOnly) {
                    this.props.personalInformationOnly(true);
                }
            })
            .catch(error => {
                this.setState({loading: false});
                this.props.dispatch(caseSetServerError(error));
                console.error(new Error().stack, error);
            });
    }

    employeeSave(data) {
        delete data['$LoggedInEmail$'];
        this.props.dispatch(addEmployeeUserAction(data))
            .then(result => {
                this.setState({loading: false});
                this.props.employeeDialogClose();

            })
            .catch(error => {
                this.setState({loading: false});
                this.props.dispatch(caseSetServerError(error));
                console.error(new Error().stack, error);
            });
    }

    employeeDialogClose() {
        this.setState({employee: undefined});
    }

    async proceed(data) {
        if (this.state.loading) {
            return;
        }

        await this.props.validateForm();
        this.setState({loading: true});
        try {
            await asyncValidateEmail(this.props);
        } catch (error) {
            console.error(new Error().stack, error);
            return;
        }

        this.setState({loading: false});
        this.props.submitForm();
        if (!isEmptyObject(this.props.errors)) {
            return;
        }

        if (this.props.loggedIn) {
            if (this.props.employee) {
                this.employeeSave(data);

            } else {
                this.save(data);
            }

        } else {
            this.proceedToCheckout(data);
        }
    }

    logIn(evt) {
        evt.preventDefault();
        browserHistory.push('/user/login');
    }

    proceedToCheckout(data) {
        let coupon = data['Coupon'];

        //
        // TODO: BUG - when changing to valid coupon, clicking signup, cancelling, clearing coupon
        // and hitting sign up again - previous discount will still be there.
        //

        this.props.dispatch(userSubscriptionValidateCoupon(coupon))
            .then((result) => {
                if (!isEmptyObject(result.data)) {
                    let couponInfo = getCouponInfo(result.data, this.state.selectedPrice);
                    if (!couponInfo) {
                        this.props.dispatch(caseSetServerError('Error processing coupon'));
                        return;
                    }

                    this.setState({
                        finalPrice: couponInfo.finalPrice,
                        couponDescription: couponInfo.couponDescription,
                    });

                } else {
                    this.setState({
                        finalPrice: this.state.selectedPrice,
                        couponDescription: ''
                    });
                }

                this.refs.StripeCheckout.onClick();
            })
            .catch((error) => {
                console.error(new Error().stack, error);
                this.setState({loading: false});
                return;
            });
    }

    deleteEmployeeConfirm(rowIndex, employee) {
        if (!isEmptyString(employee.employees.deleted_at)) {
            this.setState({
                dialogTitle: 'Forbidden',
                dialogText: 'User already deleted.',
                dialogCancel: () => {this.setState({dialogOpened: false})},
                dialogSize: 'normal',
                dialogWarning: false,
                dialogOpened: true
            });

        } else {
            this.setState({
                dialogTitle: 'Delete?',
                dialogText: `Do you really want to delete current user: ${employee.employees['FirstName'] + ' ' + employee.employees['LastName']}?`,
                dialogCancel: () => {this.setState({dialogOpened: false})},
                dialogSize: 'normal',
                dialogWarning: true,
                dialogConfirm: () => {
                    this.deleteEmployee(rowIndex, employee);
                    this.setState({dialogOpened: false})
                },
                dialogOpened: true
            });
        }
    }

    deleteEmployee(rowIndex, employee) {
        let id = parseInt(employee.employees.id);
        this.setState({
            loading: true
        });

        this.props.dispatch(deleteEmployeeUserAction({id}))
            .then((result) => {
                this.setState({
                    loading: false
                })
            })
            .catch((error) => {
                console.error(new Error().stack, error);
                this.props.dispatch(caseSetServerError(error));
                this.setState({
                    loading: false
                })
            });
    }

    checkEmail() {
        const check = async () => {
            try {
                await asyncValidateEmail(this.props);
            } catch (error) {
            }
        };

        check();
    }

    handleEmailChange(evt) {
        const name = evt.target.name;
        const value = evt.target.value;
        this.props.setFieldTouched(name, true, false);
        this.props.setFieldValue('Email', value, false);
        if (this.checkEmailTimeoutId) {
            clearTimeout(this.checkEmailTimeoutId);
            this.checkEmailTimeoutId = undefined;
        }

        this.checkEmailTimeoutId = setTimeout(() => {
            this.checkEmailTimeoutId = undefined;
            this.checkEmail();
        }, 300);
    }

    async deleteAccountConfirm() {
        try {
            this.setState({ deleteAccountDialogLoading: true });
            const result = await this.props.dispatch(userFeedbackAction(this.state.deleteAccountMessage, { deleteAccount: true }));
            if (!result) {
                console.error('Account delete request not sent.');
                this.props.dispatch(caseSetServerError('Account delete request failure.'));
                return;
            }

            this.setState({ deleteAccountDialog: false, deleteAccountDialogLoading: false });
        } catch (error) {
            console.error(new Error().stack, error);
            this.props.dispatch(caseSetServerError(error));
            this.setState({ deleteAccountDialogLoading: false });
        }
    }
    
    emailReadToggle(enabled) {
        const refresh = () => this.props.dispatch(userLogInLoadAction());
        userEmailReadAction(enabled).then(result => {
            if (result.data.type !== 'AUTHORIZATION') {
                refresh();
                return;
            }

            const popup = window.open(result.data.authUrl, 'popup', 'toolbar=0,status=0,width=500,height=500');
            if (!popup) {
                userEmailReadAction(false).then(refresh);
                this.props.dispatch(caseSetServerError('Please allow popup windows to grant the permission.'));
                return;
            }

            const timer = setInterval(() => {
                if (popup.closed) {
                    clearInterval(timer);
                    refresh();
                }
            }, 1000);

        }).catch(error => {
            this.props.dispatch(caseSetServerError(error));
        });
    }

    render() {
        const {
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            errors,
            asyncValidating,
            loggedIn,
            isOwner,
            employees,
            employee,
            personalInformationOnly = undefined,
            account,
            accountType
        } = this.props;

        // Demo accounts are throwaway sandboxes — the profile/account section
        // is read-only (the server rejects account updates for them as well).
        if (loggedIn && !employee && isDemoAccount(loggedIn)) {
            return (
                <Panel data-hj-whitelist header="My Account">
                    <p style={{ padding: 15 }}>
                        Profile settings are disabled in the live demo.
                        This is a temporary sandbox account — it is erased when you
                        log out (or after two hours). Sign up for your own account
                        to configure your profile, email, SMS and payments.
                    </p>
                </Panel>
            );
        }

        const size = findBootstrapEnvironment();
        let loading = this.state.loading;
        let panelHeader = 'Sign Up';
        let primaryBtnLabel = 'Sign Up';
        let signUpBtnCss = {};
        if (loggedIn) {
            if (employee) {
                panelHeader = 'Employee';
            } else {
                panelHeader = `${loggedIn.FirstName} ${loggedIn.LastName} (Time zone: ${loggedIn['Timezone']})`;
            }

            primaryBtnLabel = 'Save';
            if (personalInformationOnly) {
                primaryBtnLabel = 'Next';
            }
        }

        if (this.props.signupDialog) {
            panelHeader = false;
            signUpBtnCss = {
                position: 'fixed',
                top: '400px',
                marginLeft: '150px',
            }
        }

        const employeeHeaders = [
        {
            table: 'employees',
            name: 'FirstName',
            label: 'First Name',
            width: 150
        },
        {
            table: 'employees',
            name: 'LastName',
            label: 'Last Name',
            width: 150
        },
        {
            table: 'employees',
            name: 'Email',
            label: 'Email',
            width: 150
        },
        {
            table: 'employees',
            name: 'created_at',
            label: 'Created',
            width: 150
        },
        {
            table: 'employees',
            name: 'updated_at',
            label: 'Updated',
            width: 150
        }];

        // Admin user management lives on the dedicated /admin dashboard.
        let editEmployee;
        let deleteEmployeeConfirm = this.deleteEmployeeConfirm;
        let employeesPanelHeader = 'Employees';

        let employeeRows = [];
        if (employees) {
            employeeRows = employees.map((e) => {
                let row = {};
                let employee = {...e};
                employee['created_at'] = getDateFromUTC(e['created_at']);
                employee['deleted_at'] = getDateFromUTC(e['deleted_at']);
                employee['updated_at'] = getDateFromUTC(e['updated_at']);
                employee['deleted_at'] = getDateFromUTC(e['deleted_at']);
                row.employees = employee;
                return row;
            });
        }

        const personalInfo = (
            <div>
            <Row>
                <Col xs={12}>
                    <TextInput field={{
                                    name: 'FirstName',
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: errors['FirstName'],
                                    touched: touched['FirstName'],
                                    value: values['FirstName'],
                                }}
                                label="First Name"
                                disabled={loading}/>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <TextInput field={{
                                    name: 'LastName',
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: errors['LastName'],
                                    touched: touched['LastName'],
                                    value: values['LastName'],
                                }}
                                label="Last Name"
                                disabled={loading}/>
                </Col>
            </Row>
            {((isOwner && !this.props.employee) || (!loggedIn)) && (
            <React.Fragment>
            <Row>
                <Col xs={12}>
                    <TextInput field={{
                                    name: 'CompanyName',
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    error: errors['CompanyName'],
                                    touched: touched['CompanyName'],
                                    value: values['CompanyName'],
                                }}
                                label="Company Name"
                                disabled={loading}/>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <AutoComplete field={{
                                        name: 'Country',
                                        onChange: (value) => {
                                            setFieldValue('Country', value);
                                            setFieldValue('PracticeState', getStatesOptions({'Country': value})[0]);
                                        },
                                        onBlur: handleBlur,
                                        error: errors['Country'],
                                        touched: touched['Country'],
                                        value: values['Country'],
                                    }}
                                    label={"Country"}
                                    disabled={loading}
                                    options={getSupportedCountriesOptions()}
                                    allowNew={false}
                                    isClearable={false}
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <AutoComplete field={{
                                        name: 'PracticeState',
                                        onChange: (value) => { setFieldValue('PracticeState', value); },
                                        onBlur: handleBlur,
                                        error: errors['PracticeState'],
                                        touched: touched['PracticeState'],
                                        value: values['PracticeState'],
                                    }}
                                    label={getStatesLabel(values)}
                                    disabled={loading}
                                    options={getStatesOptions(values)}
                                    allowNew={false}
                                    isClearable={false}
                    />
                </Col>
            </Row>
            </React.Fragment>)}
            </div>
        );

        const saveButton = (
            <Button style={{ width: 150, ...signUpBtnCss }}
                    bsStyle={personalInformationOnly ? "secondary" : "primary"}
                    label={primaryBtnLabel}
                    loading={loading}
                    disabled={loading || (!this.state.agreeChecked && !loggedIn) || !isEmptyObject(this.props.errors)}
                    loadingLabel="Processing ..."
                    onClick={() => { this.proceed(values); }}
            />);

        if (personalInformationOnly) {
            return (
                <div>
                {personalInfo}
                <Row>
                <Col xs={12}>
                <div style={{ float: 'right' }}>
                {saveButton}
                </div>
                </Col>
                </Row>
                </div>);
        }

        const accountUiBase = (
                <div>
                {loggedIn && personalInfo}
                <Row>
                    <Col xs={12}>
                        <TextInput field={{
                                       name: 'Email',
                                       onChange: this.handleEmailChange,
                                       onBlur: this.handleEmailChange,
                                       error: errors['Email'],
                                       touched: touched['Email'],
                                       value: values['Email'],
                                   }}
                                   placeholder="This will be your login"
                                   label="Email (Username)"
                                   disabled={loading}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <LoadingProgressBar loading={asyncValidating} />
                    </Col>
                </Row>
                {!loggedIn && (
                <Row>
                    <Col xs={12}>
                        <TextInput field={{
                                       name: 'Password',
                                       onChange: handleChange,
                                       onBlur: handleBlur,
                                       error: errors['Password'],
                                       touched: touched['Password'],
                                       value: values['Password'],
                                   }}
                                   placeholder="Secret between the two of us"
                                   label="Password"
                                   disabled={loading}
                                   type="password"
                        />
                    </Col>
                </Row>)}
                {!loggedIn && (
                <Row>
                    <Col xs={12}>
                    <CheckBox field={{
                                  name: 'couponCheckbox'
                              }}
                              disabled={loading}
                              checked={this.state.couponChecked || values['Coupon']}
                              label=''
                              style={{float: 'left', marginRight: 10}}
                              onChange={(elem) => {
                                  this.setState({couponChecked: !(this.state.couponChecked || values['Coupon'])});
                                  this.props.setFieldValue('Coupon', '', true);
                          }}>
                          (Optional) Coupon
                    </CheckBox>
                    </Col>
                    {(this.state.couponChecked || values['Coupon']) && (
                    <Col xs={12}>
                        <TextInput field={{
                                       name: 'Coupon',
                                       onChange: handleChange,
                                       onBlur: handleBlur,
                                       error: errors['Coupon'],
                                       touched: touched['Coupon'],
                                       value: values['Coupon'],
                                   }}
                                   placeholder="(Optional) Discount Code"
                                   label="Coupon"
                                   disabled={loading}
                        />
                    </Col>)}
                </Row>)}
                {!loggedIn && (
                <Row>
                    <Col xs={12} md={6}>
                        <CheckBox field={{
                                  name: 'agreeCheckbox'
                              }}
                              disabled={loading}
                              checked={this.state.agreeChecked}
                              label=''
                              style={{float: 'left', marginRight: 10}}
                              onChange={(elem) => {
                                  this.setState({agreeChecked: !this.state.agreeChecked});
                          }}>
                          I agree:
                          <ConditionsAndPolicyLinks disabled={loading} openExternally={this.props.signupDialog} />
                        </CheckBox>
                    </Col>
                </Row>)}
                <br />
                <Row>
                    <Col xs={12}>
                        {!employee && (
                            <div style={{float: 'left', marginLeft: 15, width: '150px'}}>
                            {saveButton}
                            </div>)}

                        {!loggedIn && (
                            <StripeCheckout ref="StripeCheckout"
                                        token={this.signUp}
                                        stripeKey={process.env.STRIPE_PUBLIC_API_KEY}
                                        name="Case Tempo"
                                        panelLabel="Start Trial"
                                        description={this.state.couponDescription}
                                        billingAddress
                                        zipCode
                                        currency="USD"
                                        ComponentClass="div"
                                        allowRememberMe={false}
                                        email={values['Email']}
                                        closed={() => this.setState({loading: this.state.signingUp})}
                            >
                                <div />
                            </StripeCheckout>)}
                    {!loggedIn && !this.props.signupDialog && (
                    <div style={{float: 'right'}}>
                        <Button onClick={this.logIn}
                                bsStyle="link"
                                disabled={loading}
                                label="Log In"/>
                    </div>)}
                    </Col>
                    <ConfirmDialog title={this.state.dialogTitle}
                       text={this.state.dialogText}
                       warning={this.state.dialogWarning}
                       cancel={() => {this.setState({dialogOpened: false})}}
                       confirm={this.state.dialogConfirm}
                       size={this.state.dialogSize}
                       open={this.state.dialogOpened}>
                       {this.state.dialogUrl && (
                        <Iframe url={this.state.dialogUrl}
                                width="100%"
                                height="70%"
                                display="initial"
                                position="relative" />)}
                    </ConfirmDialog>
                </Row>
                </div>
        );

        if (this.props.employee) {
            return (
                <ConfirmDialog title="Employee"
                               cancel={this.props.employeeDialogClose}
                               open
                               confirm={() => {
                                    let data = this.props.values;
                                    this.proceed(data);
                               }}>
                    {accountUiBase}
                </ConfirmDialog>
            );
        }

        const emailBtn = (
            <SendEmailForm templatesFieldName="_"
                           loading={loading}
                           attachments={[]}
                           renderEmailButtonOnly
                           renderEmailButtonBsStyle="default"
                           ref="emailButton" />
        );

        const emailIntegrationUi = (
            <Row>
                <EmailSignatureDialog open={this.state.emailSignatureDialogOpened}
                                    close={ () => {
                                        this.setState({ emailSignatureDialogOpened: false });
                                    }} />
                <Col xs={12} md={6}>
                    <FormField label="Email / Calendar integration">
                    {emailBtn}
                    </FormField>
                </Col>
                <Col xs={12} md={6}>
                    <FormField label="Email signature">
                        <Button onClick={() => { this.setState({ emailSignatureDialogOpened: true }); }}
                                disabled={loading || !isEmailIntegrated(loggedIn)}
                                icon="pencil"
                                label="Edit Email Signature ..."
                                tooltip="Create / delete Email signature that will be appended at the end of your every Email."/>
                    </FormField>
                </Col>
                {isEmailIntegrated(loggedIn) && (
                <Col xs={12} md={6}>
                    <FormField label="Email conversations">
                        <div className="email-read">
                            <div className="email-read__line">
                                <div>
                                    <div className="email-read__title">Read email conversations</div>
                                    <p className="email-read__text">
                                        See the whole thread, including client replies, for emails you send from Case Tempo.
                                    </p>
                                </div>
                                <button type="button"
                                        className="email-switch"
                                        role="switch"
                                        aria-checked={!!loggedIn['EmailReadEnabled']}
                                        aria-label="Read email conversations"
                                        disabled={loading}
                                        onClick={() => this.setState({ emailReadDialog: true })} />
                            </div>
                        </div>
                <ConfirmDialog title={loggedIn['EmailReadEnabled'] ? 'Stop reading email conversations?' : 'Read email conversations?'}
                               cancel={() => this.setState({ emailReadDialog: false })}
                               confirm={() => {
                                   this.setState({ emailReadDialog: false });
                                   this.emailReadToggle(!loggedIn['EmailReadEnabled']);
                               }}
                               confirmLabel={loggedIn['EmailReadEnabled'] ? 'Turn off' : 'Turn on'}
                               open={!!this.state.emailReadDialog}
                >
                    {!loggedIn['EmailReadEnabled'] ? (
                    <div className="email-read-dialog">
                        <p>See the whole thread, including client replies, for emails you send from Case Tempo.</p>
                        <ul style={{ paddingLeft: 20 }}>
                            <li>Open a sent email in the case to read the conversation and open it in {loggedIn['GmailAccount'] ? 'Gmail' : 'Outlook'}.</li>
                            <li>View attachments or save them to the case documents with one click.</li>
                            <li>Case Tempo reads only conversations of emails sent from it.</li>
                            <li>Next you will be asked to grant read access to your {loggedIn['GmailAccount'] ? 'Gmail' : 'Outlook'}.</li>
                        </ul>
                    </div>
                    ) : (
                    <div className="email-read-dialog">
                        <p>Case Tempo will stop reading your mailbox.</p>
                        <p>The read permission you granted stays in the email connection. To remove it completely,
                           disconnect the email integration (Email / Calendar integration) and connect it again with this switch off.</p>
                    </div>
                    )}
                </ConfirmDialog>
                    </FormField>
                </Col>
                )}
                {isEmailIntegrated(loggedIn) && loggedIn['GmailAccount'] && (
                <Col xs={12} md={6}>
                    <Select field={{
                        name: 'CalendarIdList',
                        value: loggedIn['GmailCalendarId'] || 'primary',
                        onChange: (evt) => {
                            this.props.dispatch(userCalendarDefaultAction(evt.target.value));
                        }
                    }}
                    label="Default Calendar"
                    tooltip="Select calendar where tasks will be saved to."
                    disabled={!this.state.calendarIds || this.state.calendarIds.length == 0}
                    options={this.state.calendarIds || [{label: 'primary', value: 'primary'}]}
                    loading={loading}
                />
                </Col>
                )}
            </Row>
        );

        if (this.props.renderEmailIntegrationOnly) {
            return emailBtn;
        }

        const paymentButton = (
            <PaymentProvider
                renderIntegrateButtonOnly
                loading={loading}
                account={account}
                accountType={accountType}
                country={getCountry(loggedIn)}
            />
        );

        const paymentIntegrationUi = (
            <Row>
                <Col xs={12} md={6}>
                    <FormField label="Payment provider integration">
                    {paymentButton}
                    </FormField>
                </Col>
            </Row>
        );

        if (this.props.renderPaymentIntegrationOnly) {
            return paymentButton;
        }

        let mainPanel ;
        if (this.props.signupDialog) {
            mainPanel = accountUiBase;
        } else {
            mainPanel = (
                <Panel bsStyle={loggedIn ? 'default' : 'primary'}
                       data-hj-whitelist
                       style={{
                           marginLeft: loggedIn ? '15px' : 0,
                           marginRight: loggedIn ? '15px' : 0,
                       }}
                       header={panelHeader}
                >
                {accountUiBase}
                </Panel>
            );
        }

        const accountUi = (
            <Col md={6} xs={12}>
                {mainPanel}
                {loggedIn && (
                    <Row>
                    <Col xs={12}>
                        <Panel header="Reset Password"
                               data-hj-whitelist
                               style={{
                                   marginLeft: '15px',
                                   marginRight: '15px',
                               }}
                        >
                            <ResetPasswordForm hideEmail
                                               centerButton={false}
                            />
                        </Panel>
                    </Col>
                    </Row>)}
                {loggedIn && (
                    <Panel header="Email / Calendar Settings"
                           data-hj-whitelist
                           style={{ marginTop: 15, marginLeft: 15, marginRight: '15px', }}
                    >
                    {emailIntegrationUi}
                    </Panel>
                )}
                {!employee && loggedIn && isOwner && (
                    <Panel header="Cloud Storage Settings"
                           data-hj-whitelist
                           style={{ marginTop: 15, marginLeft: 15, marginRight: '15px', }}
                    >
                    <Row>
                    <Col xs={12} md={6}>
                        <FormField label="Cloud Storage integration">
                        <DriveIntegration />
                        </FormField>
                    </Col>
                    {isDriveIntegrated(loggedIn) && (
                        <React.Fragment>
                        <Col xs={12} md={6}>
                            <TextInput field={{
                                name: 'DriveRootFolder',
                                value: this.state.driveRootFolder,
                                defaultValue: loggedIn['DriveRootFolder'] || 'CaseTempo',
                                onChange: (evt) => {
                                    this.setState({driveRootFolder: evt.target.value});
                                },
                                onBlur: (evt) => {
                                    this.props.dispatch(userDriveConfigAction({DriveRootFolder: evt.target.value}));
                                }
                            }}
                            label="Root Folder"
                            tooltip="Select root folder where files will be saved to."
                            loading={loading}
                        />
                        </Col>
                        <Col xs={12} md={6}>
                            <Select field={{
                                name: 'DriveId',
                                value: loggedIn['DriveId'],
                                onChange: (evt) => {
                                    this.props.dispatch(userDriveConfigAction({DriveId: evt.target.value}));
                                }
                            }}
                            label="Default Drive"
                            tooltip="Select drive where files will be saved to."
                            disabled={!this.state.driveIds || this.state.driveIds.length == 0}
                            options={this.state.driveIds}
                            loading={loading}
                        />
                        </Col>
                        </React.Fragment>
                        )}
                    </Row>
                    </Panel>
                )}
                {!employee && loggedIn && isOwner && (
                    <Panel header="Payment Portal Integration"
                           data-hj-whitelist
                           style={{marginLeft: '15px', marginRight: '15px',}} 
                    >
                    {paymentIntegrationUi}
                    </Panel>
                )}
                {!employee && loggedIn && isOwner && (
                    <Panel header="Connect with SMS service"
                           data-hj-whitelist
                           style={{ marginLeft: '15px', marginRight: '15px' }}
                    >
                    <RegisterSmsPhoneForm />
                    </Panel>
                )}
                {!employee && loggedIn && (
                    <Row>
                        <Col xs={12}>
                            <TwoFactorAuth style={{marginLeft: '15px', marginRight: '15px'}} />
                        </Col>
                    </Row>
                )}
                {!employee && loggedIn && isOwner && (
                    <Panel header="Zapier / LawGro Api Key"
                           data-hj-whitelist
                           style={{ marginLeft: '15px', marginRight: '15px' }}
                    >
                    <RegisterSubscriptionApiKeyForm />
                    </Panel>
                )}
                {!employee && loggedIn && isOwner && (
                    <Panel header="Deleting your account"
                           data-hj-whitelist
                           style={{ marginLeft: '15px', marginRight: '15px' }}
                    >
                    <ConfirmDialog title='Delete Account'
                            cancel={() => {this.setState({deleteAccountDialog: false})}}
                            confirm={this.deleteAccountConfirm}
                            confirmLabel='Send Account Delete Request'
                            disabled={this.state.loading || this.state.deleteAccountDialogLoading}
                            open={this.state.deleteAccountDialog}
                            warning
                    >
                        <Row>
                        <Col xs={12}>
                        <TextArea field={{
                                    name: 'deleteAccountMessage',
                                    value: this.state.deleteAccountMessage,
                                    onChange: (evt) => {
                                        this.setState({deleteAccountMessage: evt.target.value});
                                    }
                                }}
                                forceFullSize
                                disabled={this.state.loading || this.state.deleteAccountDialogLoading}
                                label='Why do you want to delete your account?'
                                rows={10}
                        />
                        </Col>
                        </Row>
                    </ConfirmDialog>
                    <Button onClick={() => { this.setState({ deleteAccountDialog: true }); }}
                            style={{ width: 350 }}
                            label="Permanently Delete Account ..."
                            disabled={this.state.loading || this.state.deleteAccountDialogLoading}
                            loading={this.state.deleteAccountDialogLoading}
                            tooltip="Sends request to permanently delete your account. Afterwards all your data will be inevitably be lost!"
                    />
                    </Panel>
                )}
            </Col>
        );

        let isUserAdmin = isAdmin(loggedIn);
        return (
            <Row>
                {(!isOwner || !loggedIn) && (<Col md={3} xs={2} />)}
                {accountUi}
                {isOwner && loggedIn && !employee && !isUserAdmin && (
                    <Col md={6} xs={12}>
                        <Panel header={employeesPanelHeader}
                               style={{
                                   marginLeft: size === 'xs' || size === 'sm' ? '15px' : '-15px',
                                   marginRight: 15,
                               }}
                        >
                        {!isUserAdmin && (
                        <Row>
                            <Col xs={4}>
                                <FormField>
                                <Button onClick={() => {
                                            this.setState({employee: {}});
                                        }}
                                        disabled={loading}
                                        label="New ..."
                                        tooltip="Add new employee"/>
                                </FormField>
                            </Col>
                        </Row>)}
                        <Row>
                            <Col xs={12} style={{height: this.props.windowHeight * 0.7}}>
                                <Table
                                    headers={employeeHeaders}
                                    rows={employeeRows}
                                    editRow={editEmployee}
                                    editLabel="&nbsp;Edit"
                                    editBsStyle="primary"
                                    buttonsWidth={60}
                                    deleteRow={deleteEmployeeConfirm}
                                />
                            </Col>
                        </Row>
                        </Panel>
                    </Col>
                )}
                {!employee && this.state.employee && (
                <EmployeeFormDialog employee={this.state.employee}
                                    employeeDialogClose={this.employeeDialogClose}/>)}

            </Row>
        );
    }
}

SignUpForm.propTypes = {
    employee: PropTypes.object,
    employeeDialogClose: PropTypes.func,
    renderEmailIntegrationOnly: PropTypes.bool,
    renderPaymentIntegrationOnly: PropTypes.bool,
    personalInformationOnly: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {
    const loggedIn = state.user.loggedIn;
    const query = getUrlVars();
    const isOwner = loggedIn && loggedIn.id === state.user.owner.id;
    const Coupon = query['coupon'];
    const signupDialog = query['signupDialog'];
    let initialValues = {};
    if (ownProps.employee) {
        let loggedInEmail;
        if (loggedIn) {
            loggedInEmail = loggedIn['Email'];
        }

        initialValues = { Country: {label: 'USA'}, Coupon, ...ownProps.employee, '$LoggedInEmail$': loggedInEmail };
    } else {
        initialValues = { Country: {label: 'USA'}, Coupon, ...loggedIn };
    }

    for (let i = 0; i < fields.length; i++) {
        if (!initialValues[fields[i]]) {
            initialValues[fields[i]] = undefined;
        }
    }

    const employees = (state.user.employees || []).filter(e => isAdmin(loggedIn) ? e.id !== 1 : e.owner_id != 0);
    const {accountType, account} = getPaymentAccount(loggedIn);
    return {
        loggedIn,
        account,
        accountType,
        initialValues,
        isOwner,
        query,
        employees,
        signupDialog
    };
};


const formikWrapper = {
    mapPropsToValues: props => props.initialValues,
    validate: validateSignUpForm,
    enableReinitialize: true,
};


const SignUpFormConnected = connect(mapStateToProps)(withFormik(formikWrapper)(windowSize(SignUpForm)));

const EmployeeFormDialog = connect(mapStateToProps)(withFormik(formikWrapper)(SignUpForm));

export default SignUpFormConnected;